import { createLabeledMessages, unitJoin } from '../../../messageUtils';
const car = {
    registrationNumber: 'registrační značka',
    registrationNumber_short: 'RZ',
    vin: 'VIN',
    technicalCertificateCard: 'technický průkaz',
    technicalCertificateCard_short: 'TP',
    technicalCertificate: 'velký technický průkaz',
    technicalCertificate_short: 'VTP',
    type: 'druh',
    usage: 'užití',
    engineCapacity: 'objem',
    engineCapacityCcm: unitJoin('car:engineCapacity_label', 'ccm'),
    weight: 'hmotnost',
    weightKg: unitJoin('car:wight', 'kg'),
    startDate: 'datum uvedení do provozu',
    model: 'model',
    manufacturer: 'výrobce',
    body: 'karoserie',
    door: 'dveře',
    manufacturedFrom: 'výroba od',
    manufacturedTo: 'výroba do',
    seedCount: 'počet míst',
    transmission: 'převodovka',
    fuel: 'palivo',
    pov: 'povinné ručení',
    poc_short: 'POV',
    hav: 'havarijní pojištění',
    hav_short: 'HAV'
};
export default Object.assign({}, car, createLabeledMessages(car));
